<template>
  <div class="hello">
    <div class="handle-wrapper">
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="10"
        @on-change="loadMaterial"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button
        type="primary"
        @click="openCreateSalesRecordDrawer(detailCustomersId)"
        >新增销售记录</Button
      >
    </div>
    <div class="table-wrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        width="960"
      >
        <template slot-scope="{ row }" slot="content">
          <Poptip
            placement="bottom"
            word-wrap
            width="300"
            trigger="hover"
            :content="row.content"
          >
            <p class="content-item">{{ row.content }}</p>
          </Poptip>
        </template>
      </Table>
    </div>
    <CreateSalesRecordDrawer ref="CreateSalesRecordDrawer" />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import CreateSalesRecordDrawer from "./CreateSalesRecordDrawer";

export default {
  name: "Material",
  props: {
    // detailCustomersId: {
    //   type: String,
    //   default: null,
    // },
  },
  components: { CreateSalesRecordDrawer },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 10 + params.index + 1
            ),
        },
        {
          title: "客户",
          key: "model",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.CreateSalesRecordDrawer.openDrawer(
                        this.detailCustomersId,
                        params.row
                      );
                    },
                  },
                },
                params.row.customer.name
              ),
            ]);
          },
        },
        {
          title: "内容",
          slot: "content",
          width: 200,
        },
        {
          title: "创建人",
          key: "createdBy",
          align: "center",
          render: (h, params) => {
            return h("div", params.row.createdBy.name);
          },
        },
        {
          title: "创建时间",
          key: "createdAt",
          render: (h, params) => {
            return h(
              "div",
              dayjs(params.row.createdAt).format("YYYY-MM-DD HH:mm")
            );
          },
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.salesRecord.salesRecordList,
      totalRows: (state) => state.salesRecord.totalCounts,
      customerList: (state) => state.customer.customerList,
      detailCustomersId: (state) => state.customer.detailCustomersId,
    }),
  },
  methods: {
    ...mapActions({
      getSalesRecordList: "salesRecord/getSalesRecordListAction",
    }),
    openCreateSalesRecordDrawer() {
      this.$refs.CreateSalesRecordDrawer.openDrawer(this.detailCustomersId);
    },
    async loadMaterial(page) {
      if (page) this.page = page - 1;
      let api = { skip: this.page * 10, customer: this.detailCustomersId };
      if (this.searchText) api.searchText = this.searchText;
      try {
        this.tableLoading = true;
        await this.getSalesRecordList(api);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchMaterial() {
      this.page = 0;
      this.loadMaterial();
    },
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  height calc(100% - 48px)

  & >>> .ivu-table-wrapper
    overflow inherit !important

.content-item
  width 200px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
</style>
